"use strict"

import "./carousel"

jQuery(document).ready(()=>{
    
    jQuery(window).on("scroll",(evt)=>{
       
        let topSpace = evt.currentTarget.pageYOffset;
        //verifico se l'altezza della pagina permette l'affix
        let hPage = evt.currentTarget.innerHeight;
        let navHeight = jQuery("#header-grid").height();
        let offsetPage = (hPage - navHeight);

         console.log("Verifica scrolling modulo...", navHeight);

        if (topSpace > navHeight && offsetPage > topSpace) {
          jQuery("body").addClass("affixed");
        } else {
          jQuery("body").removeClass("affixed");
        }
    })
})